// import JSEncrypt from 'jsencrypt';

/**
 * 千分位过滤器
 * @param {*} value
 */
function thousandth(value, defaultValue = '0') {
  if (value === '' || value === null || value === undefined) return defaultValue;
  const intPart = Number(value).toFixed(0); // 获取整数部分
  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); // 将整数部分逢三一断
  return intPartFormat;
}

export default {
  install(Vue) {
    /* eslint-disable no-param-reassign */
    Vue.filter('thousandth', thousandth);
  },
};
